module.exports = __webpack_public_path__ + "static/media/DebtModule.846ba0c9.mp4";